// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import MText from '../../../../../components/Common/MText';
import Colours from '../../../../../styles/colours';

const HeadingAndSubText = ({ heading, text, children }) => (
  <div className="d-flex flex-column">
    <MText text={heading} size={12} />
    { !_.isEmpty(text) && <MText text={text} size={11} colour={Colours.Gray} /> }
    {children}
  </div>
);

HeadingAndSubText.propTypes = {
  heading:  PropTypes.string.isRequired,
  text:     PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

HeadingAndSubText.defaultProps = {
  text:     '',
  children: null,
};

export default HeadingAndSubText;
